// import React, { useState } from "react";
// import {
//   Box,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
//   Divider,
//   IconButton,
//   Drawer,
// } from "@mui/material";

// import {
//   ExpandLess,
//   ExpandMore,
//   Person,
//   Receipt,
//   EventNote,
//   AssignmentTurnedIn,
//   CheckCircle,
//   CalendarToday,
//   AttachMoney,
//   Storage,
//   GroupAdd,
//   AccountBox,
//   Group,
//   Archive,
//   Event,
//   Money,
//   AccessTime,
//   Business,
//   Assignment,
//   Search,
//   List as ListIcon,
//   Inventory,
//   FolderOpen,
//   Paid,
//   Timeline,
//   ContactPhone,
//   Email,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import "./Sidebar.css";
// import Logo from "../../Assets/infyulogo3.png";
// import { useLocation } from "react-router-dom"; // Add this import

// import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";

// const drawerWidth = 240;

// const SidebarContent = () => {
//   const location = useLocation(); // Get current location
//   const [openAdmin, setOpenAdmin] = useState(false);
//   const [openInventory, setOpenInventory] = useState(false);
//   const [openHolidays, setOpenHolidays] = useState(false);
//   const [openLeave, setOpenLeave] = useState(false);
//   const [openAttendance, setOpenAttendance] = useState(false);
//   const [openMail, setOpenMail] = useState(false);
//   const [openChat, setOpenChat] = useState(false);

//   const navigate = useNavigate();
//   const role = sessionStorage.getItem("role");

//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   const handleAdminClick = () => {
//     setOpenAdmin(!openAdmin);
//   };

//   const handleInventoryClick = () => {
//     setOpenInventory(!openInventory);
//   };

//   const handleHolidaysClick = () => {
//     setOpenHolidays(!openHolidays);
//   };

//   const handleLeaveClick = () => {
//     setOpenLeave(!openLeave);
//   };

//   const handleAttendanceClick = () => {
//     setOpenAttendance(!openAttendance);
//   };

//   const handleMailClick = () => {
//     setOpenMail(!openMail);
//   };

//   const isActive = (path) => {
//     return location.pathname === path;
//   };

//   const handleChatClick = () => {
//     setOpenChat(!openChat);
//   };

//   return (
//     <Box sx={{ width: drawerWidth }}>
//       <List>
//         <IconButton
//           edge="start"
//           aria-label="menu"
//           disableRipple
//           sx={{
//             ml: 0, // No unnecessary margin
//             p: 0,  // Remove padding around the icon
//             height: "48px", // Match navbar height
//             display: "flex",
//             alignItems: "center",
//             "&:hover": { backgroundColor: "transparent" },
//           }}
//         >
//           <img
//             src={Logo}
//             width={72}
//             height={42}
//             alt="Brand Logo"
//             style={{
//               display: "block",
//               objectFit: "contain",
//               marginTop: "-1px", // Slightly move it up if needed
//             }}
//           />
//         </IconButton>

//         {/* /////////////////////////////////Employee Mangement  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}


//         <Box sx={{ px: 2 }}> {/* px = left and right padding */}
//           <ListItem
//             button
//             onClick={() => handleNavigation("/EmployeeDashboard")}
//             className={`sidebar-item ${isActive("/EmployeeDashboard") ? "active-item" : ""}`}
//             sx={{
//               backgroundColor: isActive("/EmployeeDashboard") ? "#e3f2fd" : "inherit",
//               borderRadius: 2,
//               px: 1,
//               py: 1,
//               "&:hover": {
//                 backgroundColor: isActive("/EmployeeDashboard") ? "#bbdefb" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemIcon sx={{ minWidth: 32 }}>
//               <CalendarToday fontSize="small" />
//             </ListItemIcon>
// <ListItemText
//   disableTypography={false}
//   sx={{
//     "& .MuiTypography-root": {
//       fontWeight: 600,
//       fontSize: "0.8125rem",
//       color: "#111111", // almost black
//     },
//   }}
//   primary="Dashboard"
// />





//           </ListItem>
//         </Box>



//         <>
//           <Box sx={{ px: 2, py: 0.25 }}>
//             <ListItem
//               button
//               onClick={handleAdminClick}
//               className={`sidebar-item ${openAdmin ? "active-parent" : ""}`}
//               sx={{
//                 backgroundColor: openAdmin ? "#e3f2fd" : "inherit",
//                 borderRadius: 2,
//                 px: 1,
//                 py: 1,
//                 "&:hover": {
//                   backgroundColor: openAdmin ? "#bbdefb" : "#f5f5f5",
//                 },
//               }}
//             >
//               <ListItemIcon sx={{ minWidth: 32 }}>
//                 <GroupAdd fontSize="small" sx={{ color: openAdmin ? "#1976d2" : "inherit" }} />
//               </ListItemIcon>
//               <ListItemText
//                 primary="Employee Management"
//                 primaryTypographyProps={{
//                   fontWeight: openAdmin ? "bold" : "normal",
//                   color: openAdmin ? "#1976d2" : "inherit",
//                 }}
//               />
//               {openAdmin ? <ExpandLess sx={{ color: "#1976d2" }} /> : <ExpandMore />}
//             </ListItem>
//           </Box>

//           <Collapse in={openAdmin} timeout="auto" unmountOnExit>
//             <List component="div" disablePadding>

//               {[
//                 { label: "Holidays", path: "/HolidaysListForEmployees" },
//                 { label: "Salary Slip", path: "/MySalarySlip" },
//                 { label: "TimesSheet", path: "/timesheet" },
//                 { label: "TimesSheet List", path: "/timesheetlist" },
//               ].map(({ label, path }) => (
//               <Box key={path} sx={{ px: 2, py: 0.25 }}>
//   <ListItem
//     button
//     onClick={() => handleNavigation(path)}
//     className="sidebar-subitem"
//     sx={{
//       pl: 6,
//       py: 1,
//       borderLeft:
//         location.pathname === path
//           ? "3px solid #1976d2"
//           : "3px solid transparent",
//       backgroundColor: "transparent",
//       borderRadius: 1,
//       "&:hover": {
//         backgroundColor: "#f5f5f5",
//         borderLeft: "3px solid #1976d2",
//       },
//     }}
//   >
//     <ListItemText
//       primary={label}
//       primaryTypographyProps={{
//         fontSize: "0.7rem",
//         fontWeight: location.pathname === path ? 500 : 400,
//         color: location.pathname === path ? "#1976d2" : "#444",
//       }}
//     />
//   </ListItem>
// </Box>

//               ))}

//               {/* External Link - White Board */}
//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => (window.location.href = "https://whiteboard.infyulabs.com/")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft: "3px solid transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="White Board"
//                     primaryTypographyProps={{
//                       fontSize: "0.8rem",
//                       color: "#555",
//                     }}
//                   />
//                 </ListItem>
//               </Box>


//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/AttendancePortal")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/AttendancePortal"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Mark Attendance"
//                     primaryTypographyProps={{
//                       fontWeight: location.pathname === "/AttendancePortal" ? "bold" : "normal",
//                       color: location.pathname === "/AttendancePortal" ? "#1976d2" : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>

//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/GetMyAttendance")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/GetMyAttendance"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Attendance Records"
//                     primaryTypographyProps={{
//                       fontWeight: location.pathname === "/GetMyAttendance" ? "bold" : "normal",
//                       color: location.pathname === "/GetMyAttendance" ? "#1976d2" : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>


//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/ReimbursementForm")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/ReimbursementForm"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Reimbursement Form"
//                     primaryTypographyProps={{
//                       fontWeight: location.pathname === "/ReimbursementForm" ? "bold" : "normal",
//                       color: location.pathname === "/ReimbursementForm" ? "#1976d2" : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>

//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/MyReimbursements")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/MyReimbursements"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="My Reimbursements"
//                     primaryTypographyProps={{
//                       fontWeight: location.pathname === "/MyReimbursements" ? "bold" : "normal",
//                       color: location.pathname === "/MyReimbursements" ? "#1976d2" : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>

//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/ReimbursementReport")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/ReimbursementReport"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Reimbursement Report"
//                     primaryTypographyProps={{
//                       fontWeight:
//                         location.pathname === "/ReimbursementReport" ? "bold" : "normal",
//                       color:
//                         location.pathname === "/ReimbursementReport"
//                           ? "#1976d2"
//                           : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>

//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/calendarView")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/calendarView"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Calendar"
//                     primaryTypographyProps={{
//                       fontWeight:
//                         location.pathname === "/calendarView" ? "bold" : "normal",
//                       color:
//                         location.pathname === "/calendarView"
//                           ? "#1976d2"
//                           : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>


//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/MyInventories")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/MyInventories"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="My Inventories"
//                     primaryTypographyProps={{
//                       fontWeight:
//                         location.pathname === "/MyInventories" ? "bold" : "normal",
//                       color:
//                         location.pathname === "/MyInventories"
//                           ? "#1976d2"
//                           : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>

//               <Box sx={{ px: 2, py: 0.25 }}>
//                 <ListItem
//                   button
//                   onClick={() => handleNavigation("/ResetPassword")}
//                   className="sidebar-subitem"
//                   sx={{
//                     pl: 6,
//                     py: 1,
//                     borderLeft:
//                       location.pathname === "/ResetPassword"
//                         ? "3px solid #1976d2"
//                         : "3px solid transparent",
//                     backgroundColor: "transparent",
//                     borderRadius: 1,
//                     "&:hover": {
//                       backgroundColor: "#f5f5f5",
//                       borderLeft: "3px solid #1976d2",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary="Reset Password"
//                     primaryTypographyProps={{
//                       fontWeight:
//                         location.pathname === "/ResetPassword" ? "bold" : "normal",
//                       color:
//                         location.pathname === "/ResetPassword"
//                           ? "#1976d2"
//                           : "#555",
//                       fontSize: "0.75rem",
//                     }}
//                   />
//                 </ListItem>
//               </Box>



//             </List>
//           </Collapse>

//         </>
//         {/* /////////////////////////////////Employee Mangement ends /////////////////////////////////////////////////////////////////////////////////// */}
//         {/* ///////////////////////////////// InventoryList Starts /////////////////////////////////////////////////////////////////////////////////// */}

//         {role === "admin" && (
//           <>
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={handleInventoryClick}
//                 className={`sidebar-item ${openInventory ? "active-parent" : ""}`}
//                 sx={{
//                   backgroundColor: openInventory ? "#e3f2fd" : "inherit",
//                   borderRadius: 2,
//                   px: 1, // ✅ reduced spacing
//                   py: 1,
//                   "&:hover": {
//                     backgroundColor: openInventory ? "#bbdefb" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 28 }}>
//                   <Inventory fontSize="small" sx={{ color: openInventory ? "#1976d2" : "inherit" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Inventory Management"
//                   primaryTypographyProps={{
//                     fontWeight: openInventory ? "bold" : "normal",
//                     color: openInventory ? "#1976d2" : "inherit",
//                   }}
//                 />
//                 {openInventory ? <ExpandLess sx={{ color: "#1976d2" }} /> : <ExpandMore />}
//               </ListItem>
//             </Box>

//             <Collapse in={openInventory} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 {[
//                   { label: "Inventory Overview", path: "/InventoryList" },
//                   { label: "Detailed Inventory Record", path: "/InventorySearch" },
//                   { label: "Assign Inventory", path: "/AssignInventoryToEmployee" },
//                   { label: "Office Inventory", path: "/InventoryForm" },
//                 ].map(({ label, path }) => (
//                   <Box key={path} sx={{ px: 2, py: 0.25 }}>
//                     <ListItem
//                       button
//                       onClick={() => handleNavigation(path)}
//                       className="sidebar-subitem"
//                       sx={{
//                         pl: 6, // ✅ shift text right
//                         py: 1,
//                         borderLeft:
//                           location.pathname === path
//                             ? "3px solid #1976d2"
//                             : "3px solid transparent",
//                         backgroundColor: "transparent",
//                         borderRadius: 1,
//                         "&:hover": {
//                           backgroundColor: "#f5f5f5",
//                           borderLeft: "3px solid #1976d2",
//                         },
//                       }}
//                     >
//                       <ListItemText
//                         primary={label}
//                         primaryTypographyProps={{
//                           fontSize: "0.75rem",
//                           fontWeight: location.pathname === path ? "bold" : "normal",
//                           color: location.pathname === path ? "#1976d2" : "#555",
//                         }}
//                       />
//                     </ListItem>
//                   </Box>
//                 ))}


//               </List>
//             </Collapse>

//           </>
//         )}
//         {/* ///////////////////////////////// InventoryList ends /////////////////////////////////////////////////////////////////////////////////// */}
//         {/* ///////////////////////////////// Admin starts /////////////////////////////////////////////////////////////////////////////////// */}

//         {role === "admin" && (
//           <>
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={handleHolidaysClick}
//                 className={`sidebar-item ${openHolidays ? "active-parent" : ""}`}
//                 sx={{
//                   backgroundColor: openHolidays ? "#e3f2fd" : "inherit",
//                   borderRadius: 2,
//                   px: 1,
//                   py: 1,
//                   "&:hover": {
//                     backgroundColor: openHolidays ? "#bbdefb" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 32 }}>
//                   <CalendarToday
//                     fontSize="small"
//                     sx={{ color: openHolidays ? "#1976d2" : "inherit" }}
//                   />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Admin Management"
//                   primaryTypographyProps={{
//                     fontWeight: openHolidays ? "bold" : "normal",
//                     color: openHolidays ? "#1976d2" : "inherit",
//                   }}
//                 />
//                 {openHolidays ? (
//                   <ExpandLess sx={{ color: "#1976d2" }} />
//                 ) : (
//                   <ExpandMore />
//                 )}
//               </ListItem>
//             </Box>

//             <Collapse in={openHolidays} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding>
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/holidays")}
//                     className="sidebar-subitem"
//                     disableGutters
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/holidays"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Holiday Dashboard"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/holidays" ? "bold" : "normal",
//                         color: location.pathname === "/holidays" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>



//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/create-employee")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6, // 👈 shift text to the right
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/create-employee"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Register Employee"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/create-employee" ? "bold" : "normal",
//                         color: location.pathname === "/create-employee" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/EmployeeList")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/EmployeeList"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Employee Directory"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/EmployeeList" ? "bold" : "normal",
//                         color: location.pathname === "/EmployeeList" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 {/* Archived Employees */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/ArchivedEmployeeList")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/ArchivedEmployeeList"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Archived Employees"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/ArchivedEmployeeList" ? "bold" : "normal",
//                         color: location.pathname === "/ArchivedEmployeeList" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>



//                 {/* Generate Salary Slip */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/SalarySlipForm")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/SalarySlipForm"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Generate Salary Slip"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/SalarySlipForm" ? "bold" : "normal",
//                         color: location.pathname === "/SalarySlipForm" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 {/* Role based List */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/ListByRole")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/ListByRole"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Role based List"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/ListByRole" ? "bold" : "normal",
//                         color: location.pathname === "/ListByRole" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>


//                 {/* Contact Details */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/contactdetail")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/contactdetail"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Contact Details"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/contactdetail" ? "bold" : "normal",
//                         color: location.pathname === "/contactdetail" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 {/* Attendance Lookup */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/AdminAttendanceLookup")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/AdminAttendanceLookup"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Attendance Lookup"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/AdminAttendanceLookup" ? "bold" : "normal",
//                         color: location.pathname === "/AdminAttendanceLookup" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 {/* Expense Dashboard */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/ExpenseDashboard")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/ExpenseDashboard"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Expense Dashboard"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/ExpenseDashboard" ? "bold" : "normal",
//                         color: location.pathname === "/ExpenseDashboard" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>



//                 {/* Reimbursement Summary */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/ReimbursementList")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/ReimbursementList"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Reimbursement Summary"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/ReimbursementList" ? "bold" : "normal",
//                         color: location.pathname === "/ReimbursementList" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>

//                 {/* Employee Detail */}
//                 <Box sx={{ px: 2, py: 0.25 }}>
//                   <ListItem
//                     button
//                     onClick={() => handleNavigation("/EmployeeDetail")}
//                     className="sidebar-subitem"
//                     sx={{
//                       pl: 6,
//                       py: 1,
//                       borderLeft:
//                         location.pathname === "/EmployeeDetail"
//                           ? "3px solid #1976d2"
//                           : "3px solid transparent",
//                       backgroundColor: "transparent",
//                       borderRadius: 1,
//                       "&:hover": {
//                         backgroundColor: "#f5f5f5",
//                         borderLeft: "3px solid #1976d2",
//                       },
//                     }}
//                   >
//                     <ListItemText
//                       primary="Employee Detail"
//                       primaryTypographyProps={{
//                         fontSize: "0.75rem",
//                         fontWeight: location.pathname === "/EmployeeDetail" ? "bold" : "normal",
//                         color: location.pathname === "/EmployeeDetail" ? "#1976d2" : "#555",
//                       }}
//                     />
//                   </ListItem>
//                 </Box>


//               </List>
//             </Collapse>

//           </>
//         )}

//         {/* Leave Management - Parent */}
//         <Box sx={{ px: 2, py: 0.25 }}>
//           <ListItem
//             button
//             onClick={handleLeaveClick}
//             className={`sidebar-item ${openLeave ? "active-parent" : ""}`}
//             sx={{
//               backgroundColor: openLeave ? "#e3f2fd" : "inherit",
//               px: 1,
//               py: 1,
//               borderRadius: 2,
//               "&:hover": {
//                 backgroundColor: openLeave ? "#bbdefb" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemIcon sx={{ minWidth: 32 }}>
//               <EventNote
//                 fontSize="small"
//                 sx={{ color: openLeave ? "#1976d2" : "inherit" }}
//               />
//             </ListItemIcon>
//             <ListItemText
//               primary="Leave Management"
//               primaryTypographyProps={{
//                 fontWeight: openLeave ? "bold" : "normal",
//                 color: openLeave ? "#1976d2" : "inherit",
//               }}
//             />
//             {openLeave ? (
//               <ExpandLess sx={{ color: "#1976d2" }} />
//             ) : (
//               <ExpandMore />
//             )}
//           </ListItem>
//         </Box>

//         {/* Leave Management - Children */}
//         <Collapse in={openLeave} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>

//             {/* Apply For Leave */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/ApplyForLeave")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/ApplyForLeave"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Apply For Leave"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight:
//                       location.pathname === "/ApplyForLeave" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/ApplyForLeave" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//             {/* Leave Records */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/LeaveRequests")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/LeaveRequests"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Leave Records"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight:
//                       location.pathname === "/LeaveRequests" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/LeaveRequests" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>


//           </List>
//         </Collapse>

//         {/* Email Management - Parent */}
//         <Box sx={{ px: 2, py: 0.25 }}>
//           <ListItem
//             button
//             onClick={handleMailClick}
//             className={`sidebar-item ${openMail ? "active-parent" : ""}`}
//             sx={{
//               backgroundColor: openMail ? "#e3f2fd" : "inherit",
//               px: 1,
//               py: 1,
//               borderRadius: 2,
//               "&:hover": {
//                 backgroundColor: openMail ? "#bbdefb" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemIcon sx={{ minWidth: 32 }}>
//               <Email
//                 fontSize="small"
//                 sx={{ color: openMail ? "#1976d2" : "#555555" }}
//               />
//             </ListItemIcon>
//             <ListItemText
//               primary="Email Management"
//               primaryTypographyProps={{
//                 fontWeight: openMail ? "bold" : "normal",
//                 color: openMail ? "#1976d2" : "#555555",
//                 fontSize: "0.875rem",
//               }}
//             />
//             {openMail ? (
//               <ExpandLess sx={{ color: "#1976d2" }} />
//             ) : (
//               <ExpandMore />
//             )}
//           </ListItem>
//         </Box>

//         {/* Email Management - Children */}
//         <Collapse in={openMail} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>

//             {/* Compose Mail */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/SendMessage")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/SendMessage"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Compose Mail"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight:
//                       location.pathname === "/SendMessage" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/SendMessage" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//             {/* Inbox */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/MyMessages")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/MyMessages"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Inbox"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight:
//                       location.pathname === "/MyMessages" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/MyMessages" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//             {/* Sent */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/MySentMessages")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/MySentMessages"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Sent"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight:
//                       location.pathname === "/MySentMessages" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/MySentMessages" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//           </List>
//         </Collapse>




//         {/* Chat Section */}
//         {/* Chat Section - Parent */}
//         <Box sx={{ px: 2, py: 0.25 }}>
//           <ListItem
//             button
//             onClick={handleChatClick}
//             className={`sidebar-item ${openChat ? "active-parent" : ""}`}
//             sx={{
//               backgroundColor: openChat ? "#e3f2fd" : "inherit",
//               px: 1,
//               py: 1,
//               borderRadius: 2,
//               "&:hover": {
//                 backgroundColor: openChat ? "#bbdefb" : "#f5f5f5",
//               },
//             }}
//           >
//             <ListItemIcon sx={{ minWidth: 32 }}>
//               <Email fontSize="small" sx={{ color: openChat ? "#1976d2" : "#555555" }} />
//             </ListItemIcon>
//             <ListItemText
//               primary="Chat Section"
//               primaryTypographyProps={{
//                 fontWeight: openChat ? "bold" : "normal",
//                 color: openChat ? "#1976d2" : "#555555",
//                 fontSize: "0.875rem",
//               }}
//             />
//             {openChat ? <ExpandLess sx={{ color: "#1976d2" }} /> : <ExpandMore />}
//           </ListItem>
//         </Box>

//         {/* Chat Section - Children */}
//         <Collapse in={openChat} timeout="auto" unmountOnExit>
//           <List component="div" disablePadding>

//             {/* Chat */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/chatboard")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/chatboard"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Chat"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight: location.pathname === "/chatboard" ? "bold" : "normal",
//                     color: location.pathname === "/chatboard" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//             {/* Group Chat */}
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/groupchatboard")}
//                 className="sidebar-subitem"
//                 sx={{
//                   pl: 6,
//                   py: 1,
//                   borderLeft:
//                     location.pathname === "/groupchatboard"
//                       ? "3px solid #1976d2"
//                       : "3px solid transparent",
//                   backgroundColor: "transparent",
//                   borderRadius: 1,
//                   "&:hover": {
//                     backgroundColor: "#f5f5f5",
//                     borderLeft: "3px solid #1976d2",
//                   },
//                 }}
//               >
//                 <ListItemText
//                   primary="Group Chat"
//                   primaryTypographyProps={{
//                     fontSize: "0.75rem",
//                     fontWeight: location.pathname === "/groupchatboard" ? "bold" : "normal",
//                     color: location.pathname === "/groupchatboard" ? "#1976d2" : "#555",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//           </List>
//         </Collapse>


//         {/* Employees Leave Requests */}
//         {(role === "admin" ||
//           role === "manager" ||
//           role === "store manager") && (
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/ManagerleaveRequest")}
//                 className="sidebar-item"
//                 sx={{
//                   backgroundColor:
//                     location.pathname === "/ManagerleaveRequest" ? "#e3f2fd" : "inherit",
//                   borderRadius: 2,
//                   px: 1,
//                   py: 1,
//                   "&:hover": {
//                     backgroundColor:
//                       location.pathname === "/ManagerleaveRequest" ? "#bbdefb" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 32 }}>
//                   <GroupAdd
//                     fontSize="small"
//                     sx={{
//                       color:
//                         location.pathname === "/ManagerleaveRequest" ? "#1976d2" : "#555555",
//                     }}
//                   />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Employees Leave Requests"
//                   primaryTypographyProps={{
//                     fontWeight:
//                       location.pathname === "/ManagerleaveRequest" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/ManagerleaveRequest" ? "#1976d2" : "#555555",
//                     fontSize: "0.875rem",
//                   }}
//                 />
//               </ListItem>
//             </Box>


//           )}


//         {/* Add Notification */}
//         {(role === "admin" ||
//           role === "manager" ||
//           role === "store manager") && (
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/NotificationForm")}
//                 className="sidebar-item"
//                 sx={{
//                   backgroundColor:
//                     location.pathname === "/NotificationForm" ? "#e3f2fd" : "inherit",
//                   px: 1,
//                   py: 1,
//                   borderRadius: 2,
//                   "&:hover": {
//                     backgroundColor:
//                       location.pathname === "/NotificationForm" ? "#bbdefb" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 32 }}>
//                   <AssignmentTurnedIn
//                     fontSize="small"
//                     sx={{
//                       color:
//                         location.pathname === "/NotificationForm" ? "#1976d2" : "#555555",
//                     }}
//                   />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Add Notification"
//                   primaryTypographyProps={{
//                     fontWeight:
//                       location.pathname === "/NotificationForm" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/NotificationForm" ? "#1976d2" : "#555555",
//                     fontSize: "0.875rem",
//                   }}
//                 />
//               </ListItem>
//             </Box>


//           )}


//         {/* Timesheet Analysis */}
//         {(role === "admin" ||
//           role === "manager" ||
//           role === "store manager") && (
//             <Box sx={{ px: 2, py: 0.25 }}>
//               <ListItem
//                 button
//                 onClick={() => handleNavigation("/timesheetacess")}
//                 className="sidebar-item"
//                 sx={{
//                   backgroundColor:
//                     location.pathname === "/timesheetacess" ? "#e3f2fd" : "inherit",
//                   px: 1,
//                   py: 1,
//                   borderRadius: 2,
//                   "&:hover": {
//                     backgroundColor:
//                       location.pathname === "/timesheetacess" ? "#bbdefb" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ minWidth: 32 }}>
//                   <AssignmentTurnedIn
//                     fontSize="small"
//                     sx={{
//                       color:
//                         location.pathname === "/timesheetacess" ? "#1976d2" : "#555555",
//                     }}
//                   />
//                 </ListItemIcon>
//                 <ListItemText
//                   primary="Timesheet Analysis"
//                   primaryTypographyProps={{
//                     fontWeight:
//                       location.pathname === "/timesheetacess" ? "bold" : "normal",
//                     color:
//                       location.pathname === "/timesheetacess" ? "#1976d2" : "#555555",
//                     fontSize: "0.875rem",
//                   }}
//                 />
//               </ListItem>
//             </Box>

//           )}

//       </List>
//     </Box>
//   );
// };

// const Sidebar = ({ mobileOpen, handleDrawerToggle }) => {
//   // const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Render SidebarContent and pass navigation handler
//   const drawer = <SidebarContent />;

//   return (
//     <Box
//       component="nav"
//       sx={{
//         width: { sm: drawerWidth },
//         flexShrink: { sm: 0 },
//         position: "relative",
//       }}
//       aria-label="sidebar navigation"
//     >
//       {isMobile ? (
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{
//             keepMounted: true,
//           }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               boxSizing: "border-box",
//               width: drawerWidth,
//               paddingRight: "12px", // ← Add this
//             },
//           }}

//         >
//           {drawer}
//         </Drawer>
//       ) : (
//         <Drawer
//           variant="permanent"
//           open
//           sx={{
//             display: { xs: "none", sm: "block" },

//           }}
//         >
//           {drawer}
//         </Drawer>
//       )}
//     </Box>
//   );
// };

// export default Sidebar;













///////////////////Rishabh version start



import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Divider,
  IconButton,
  Drawer,
} from "@mui/material";

import {
  ExpandLess,
  ExpandMore,
  Person,
  Receipt,
  EventNote,
  AssignmentTurnedIn,
  CheckCircle,
  CalendarToday,
  AttachMoney,
  Storage,
  GroupAdd,
  AccountBox,
  Group,
  Archive,
  Event,
  Money,
  AccessTime,
  Business,
  Assignment,
  Search,
  List as ListIcon,
  Inventory,
  FolderOpen,
  Paid,
  Timeline,
  ContactPhone,
  Email,
  LocationOn,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "./Sidebar.css";
import Logo from "../../Assets/infyulogo3.png";
import { useLocation } from "react-router-dom"; // Add this import

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const drawerWidth = 260;

const SidebarContent = () => {
  const location = useLocation(); // Get current location
  // const navigate = useNavigate();
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openInventory, setOpenInventory] = useState(false);
  const [openHolidays, setOpenHolidays] = useState(false);
   const [openLeave, setOpenLeave] = useState(() => {
    return location.hash.includes('#leave-management');
  });

  const [openAttendance, setOpenAttendance] = useState(false);
  const [openMail, setOpenMail] = useState(false);
  const [openChat, setOpenChat] = useState(false);

  const navigate = useNavigate();
  const role = sessionStorage.getItem("role");

  const handleNavigation = (path) => {
    navigate(path);
  };

  const closeAllSections = (except) => {
    if (except !== "admin") setOpenAdmin(false);
    if (except !== "inventory") setOpenInventory(false);
    if (except !== "holidays") setOpenHolidays(false);
    if (except !== "leave") setOpenLeave(false);
    if (except !== "attendance") setOpenAttendance(false);
    if (except !== "mail") setOpenMail(false);
    if (except !== "chat") setOpenChat(false);
  };

  const handleAdminClick = () => {
    closeAllSections("admin");
    setOpenAdmin(!openAdmin);
  };

  const handleInventoryClick = () => {
    closeAllSections("inventory");
    setOpenInventory(!openInventory);
  };

  const handleHolidaysClick = () => {
    closeAllSections("holidays");
    setOpenHolidays(!openHolidays);
  };

  const handleLeaveClick = () => {
    closeAllSections("leave");
    setOpenLeave((prev) => !prev);
  };

  const handleLeaveChildNavigation = (path) => {
    navigate(path);
    if (!openLeave) {
      setOpenLeave(true);
      navigate(`${path}#leave-management`, { replace: true });
    }
  };

  const handleAttendanceClick = () => {
    closeAllSections("attendance");
    setOpenAttendance(!openAttendance);
  };

  const handleMailClick = () => {
    closeAllSections("mail");
    setOpenMail(!openMail);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleChatClick = () => {
    closeAllSections("chat");
    setOpenChat(!openChat);
  };

  return (
    <Box
      className="dark-sidebar-scroll"
      sx={{
        width: drawerWidth,
        height: "100%",
        bgcolor: "#1a1d21",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <List sx={{ pt: 1.5 }}>
        {/* ===== Dashboard (standalone) ===== */}
        <ListItem
            button
            onClick={() => handleNavigation("/EmployeeDashboard")}
            className={`sidebar-item ${isActive("/EmployeeDashboard") ? "active-item" : ""}`}
            sx={{
              borderRadius: "8px",
              mx: 1,
              py: 0.8,
              px: 1.5,
              mb: 0.5,
              backgroundColor: isActive("/EmployeeDashboard")
                ? "rgba(102,126,234,0.15)"
                : "transparent",
              borderLeft: isActive("/EmployeeDashboard")
                ? "3px solid #667eea"
                : "3px solid transparent",
              "&:hover": {
                backgroundColor: isActive("/EmployeeDashboard")
                  ? "rgba(102,126,234,0.2)"
                  : "rgba(255,255,255,0.06)",
              },
              transition: "all 0.15s ease",
            }}
          >
            <ListItemIcon sx={{ minWidth: 32 }}>
              <CalendarToday
                sx={{
                  fontSize: 18,
                  color: isActive("/EmployeeDashboard")
                    ? "#667eea"
                    : "rgba(255,255,255,0.5)",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                fontWeight: 600,
                fontSize: "0.8125rem",
                color: isActive("/EmployeeDashboard")
                  ? "#fff"
                  : "rgba(255,255,255,0.85)",
              }}
            />

          </ListItem>

        {/* ===== Employee Management Section ===== */}
        <>
          <Box
            sx={{
              px: 2,
              pt: 2,
              pb: 0.5,
              fontSize: "0.65rem",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "1.2px",
              color: "rgba(255,255,255,0.4)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              userSelect: "none",
            }}
            onClick={handleAdminClick}
          >
            Employee Management
            {openAdmin ? (
              <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
            ) : (
              <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
            )}
          </Box>

          <Collapse in={openAdmin} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pb: 0.5 }}>
              {[
                { label: "Holidays", path: "/HolidaysListForEmployees" },
                { label: "Salary Slip", path: "/MySalarySlip" },
                { label: "TimesSheet", path: "/timesheet" },
                { label: "TimesSheet List", path: "/timesheetlist" },
              ].map(({ label, path }) => (
                <ListItem
                  key={path}
                  button
                  onClick={() => handleNavigation(path)}
                  className="sidebar-subitem"
                  sx={{
                    pl: 5,
                    py: 0.5,
                    mx: 1,
                    borderRadius: "6px",
                    backgroundColor: isActive(path)
                      ? "rgba(102,126,234,0.1)"
                      : "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.04)",
                    },
                    transition: "all 0.15s ease",
                  }}
                >
                  <Box
                    className={`child-dot ${isActive(path) ? "active" : ""}`}
                    sx={{ mr: 1.5 }}
                  />
                  <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                      fontSize: "0.8rem",
                      fontWeight: isActive(path) ? 500 : 400,
                      color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                    }}
                  />
                </ListItem>
              ))}

              {/* External Link - White Board */}
              <ListItem
                button
                onClick={() => (window.location.href = "https://whiteboard.infyulabs.com/")}
                className="sidebar-subitem"
                sx={{
                  pl: 5,
                  py: 0.5,
                  mx: 1,
                  borderRadius: "6px",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.04)",
                  },
                  transition: "all 0.15s ease",
                }}
              >
                <Box className="child-dot" sx={{ mr: 1.5 }} />
                <ListItemText
                  primary="White Board"
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    color: "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItem>

              {[
                { label: "Mark Attendance", path: "/AttendancePortal" },
                { label: "Attendance Records", path: "/GetMyAttendance" },
                { label: "Reimbursement Form", path: "/ReimbursementForm" },
                { label: "My Reimbursements", path: "/MyReimbursements" },
                { label: "Reimbursement Report", path: "/ReimbursementReport" },
                { label: "Calendar", path: "/calendarView" },
                { label: "My Inventories", path: "/MyInventories" },
                { label: "Reset Password", path: "/ResetPassword" },
              ].map(({ label, path }) => (
                <ListItem
                  key={path}
                  button
                  onClick={() => handleNavigation(path)}
                  className="sidebar-subitem"
                  sx={{
                    pl: 5,
                    py: 0.5,
                    mx: 1,
                    borderRadius: "6px",
                    backgroundColor: isActive(path)
                      ? "rgba(102,126,234,0.1)"
                      : "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.04)",
                    },
                    transition: "all 0.15s ease",
                  }}
                >
                  <Box
                    className={`child-dot ${isActive(path) ? "active" : ""}`}
                    sx={{ mr: 1.5 }}
                  />
                  <ListItemText
                    primary={label}
                    primaryTypographyProps={{
                      fontSize: "0.8rem",
                      fontWeight: isActive(path) ? 500 : 400,
                      color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Collapse>
        </>

        {/* ===== Inventory Management (admin only) ===== */}
        {role === "admin" && (
          <>
            <Box
              sx={{
                px: 2,
                pt: 2,
                pb: 0.5,
                fontSize: "0.65rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "1.2px",
                color: "rgba(255,255,255,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={handleInventoryClick}
            >
              Inventory
              {openInventory ? (
                <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
              ) : (
                <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
              )}
            </Box>

            <Collapse in={openInventory} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pb: 0.5 }}>
                {[
                  { label: "Inventory Overview", path: "/InventoryList" },
                  { label: "Detailed Inventory Record", path: "/InventorySearch" },
                  { label: "Assign Inventory", path: "/AssignInventoryToEmployee" },
                  { label: "Office Inventory", path: "/InventoryForm" },
                ].map(({ label, path }) => (
                  <ListItem
                    key={path}
                    button
                    onClick={() => handleNavigation(path)}
                    className="sidebar-subitem"
                    sx={{
                      pl: 5,
                      py: 0.5,
                      mx: 1,
                      borderRadius: "6px",
                      backgroundColor: isActive(path)
                        ? "rgba(102,126,234,0.1)"
                        : "transparent",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.04)",
                      },
                      transition: "all 0.15s ease",
                    }}
                  >
                    <Box
                      className={`child-dot ${isActive(path) ? "active" : ""}`}
                      sx={{ mr: 1.5 }}
                    />
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{
                        fontSize: "0.8rem",
                        fontWeight: isActive(path) ? 500 : 400,
                        color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}

        {/* ===== Admin Management (admin only) ===== */}
        {role === "admin" && (
          <>
            <Box
              sx={{
                px: 2,
                pt: 2,
                pb: 0.5,
                fontSize: "0.65rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: "1.2px",
                color: "rgba(255,255,255,0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                userSelect: "none",
              }}
              onClick={handleHolidaysClick}
            >
              Admin
              {openHolidays ? (
                <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
              ) : (
                <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
              )}
            </Box>

            <Collapse in={openHolidays} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pb: 0.5 }}>
                {[
                  { label: "Holiday Dashboard", path: "/holidays" },
                  { label: "Register Employee", path: "/create-employee" },
                  { label: "Employee Directory", path: "/EmployeeList" },
                  { label: "Archived Employees", path: "/ArchivedEmployeeList" },
                  { label: "Generate Salary Slip", path: "/SalarySlipForm" },
                  { label: "Role based List", path: "/ListByRole" },
                  { label: "Contact Details", path: "/contactdetail" },
                  { label: "Attendance Lookup", path: "/AdminAttendanceLookup" },
                  { label: "Expense Dashboard", path: "/ExpenseDashboard" },
                  { label: "Reimbursement Summary", path: "/ReimbursementList" },
                  { label: "Employee Detail", path: "/EmployeeDetail" },
                ].map(({ label, path }) => (
                  <ListItem
                    key={path}
                    button
                    onClick={() => handleNavigation(path)}
                    className="sidebar-subitem"
                    sx={{
                      pl: 5,
                      py: 0.5,
                      mx: 1,
                      borderRadius: "6px",
                      backgroundColor: isActive(path)
                        ? "rgba(102,126,234,0.1)"
                        : "transparent",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.04)",
                      },
                      transition: "all 0.15s ease",
                    }}
                  >
                    <Box
                      className={`child-dot ${isActive(path) ? "active" : ""}`}
                      sx={{ mr: 1.5 }}
                    />
                    <ListItemText
                      primary={label}
                      primaryTypographyProps={{
                        fontSize: "0.8rem",
                        fontWeight: isActive(path) ? 500 : 400,
                        color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </>
        )}

        {/* ===== Leave Management ===== */}
        <Box
          sx={{
            px: 2,
            pt: 2,
            pb: 0.5,
            fontSize: "0.65rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "1.2px",
            color: "rgba(255,255,255,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={handleLeaveClick}
        >
          Leave
          {openLeave ? (
            <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
          ) : (
            <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
          )}
        </Box>

        <Collapse in={openLeave} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pb: 0.5 }}>
            {[
              { label: "Apply For Leave", path: "/ApplyForLeave" },
              { label: "Leave Records", path: "/LeaveRequests" },
              { label: "Overtime Request", path: "/OvertimeRequest" },
            ].map(({ label, path }) => (
              <ListItem
                key={path}
                button
                onClick={() => handleLeaveChildNavigation(path)}
                className="sidebar-subitem"
                sx={{
                  pl: 5,
                  py: 0.5,
                  mx: 1,
                  borderRadius: "6px",
                  backgroundColor: isActive(path)
                    ? "rgba(102,126,234,0.1)"
                    : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.04)",
                  },
                  transition: "all 0.15s ease",
                }}
              >
                <Box
                  className={`child-dot ${isActive(path) ? "active" : ""}`}
                  sx={{ mr: 1.5 }}
                />
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    fontWeight: isActive(path) ? 500 : 400,
                    color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Collapse>

        {/* ===== Email Management ===== */}
        <Box
          sx={{
            px: 2,
            pt: 2,
            pb: 0.5,
            fontSize: "0.65rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "1.2px",
            color: "rgba(255,255,255,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={handleMailClick}
        >
          Email
          {openMail ? (
            <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
          ) : (
            <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
          )}
        </Box>

        <Collapse in={openMail} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pb: 0.5 }}>
            {[
              { label: "Compose Mail", path: "/SendMessage" },
              { label: "Inbox", path: "/MyMessages" },
              { label: "Sent", path: "/MySentMessages" },
            ].map(({ label, path }) => (
              <ListItem
                key={path}
                button
                onClick={() => handleNavigation(path)}
                className="sidebar-subitem"
                sx={{
                  pl: 5,
                  py: 0.5,
                  mx: 1,
                  borderRadius: "6px",
                  backgroundColor: isActive(path)
                    ? "rgba(102,126,234,0.1)"
                    : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.04)",
                  },
                  transition: "all 0.15s ease",
                }}
              >
                <Box
                  className={`child-dot ${isActive(path) ? "active" : ""}`}
                  sx={{ mr: 1.5 }}
                />
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    fontWeight: isActive(path) ? 500 : 400,
                    color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Collapse>

        {/* ===== Chat Section ===== */}
        <Box
          sx={{
            px: 2,
            pt: 2,
            pb: 0.5,
            fontSize: "0.65rem",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "1.2px",
            color: "rgba(255,255,255,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={handleChatClick}
        >
          Chat
          {openChat ? (
            <ExpandLess sx={{ fontSize: 16, color: "rgba(255,255,255,0.4)" }} />
          ) : (
            <ExpandMore sx={{ fontSize: 16, color: "rgba(255,255,255,0.3)" }} />
          )}
        </Box>

        <Collapse in={openChat} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pb: 0.5 }}>
            {[
              { label: "Chat", path: "/chatboard" },
              { label: "Group Chat", path: "/groupchatboard" },
            ].map(({ label, path }) => (
              <ListItem
                key={path}
                button
                onClick={() => handleNavigation(path)}
                className="sidebar-subitem"
                sx={{
                  pl: 5,
                  py: 0.5,
                  mx: 1,
                  borderRadius: "6px",
                  backgroundColor: isActive(path)
                    ? "rgba(102,126,234,0.1)"
                    : "transparent",
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.04)",
                  },
                  transition: "all 0.15s ease",
                }}
              >
                <Box
                  className={`child-dot ${isActive(path) ? "active" : ""}`}
                  sx={{ mr: 1.5 }}
                />
                <ListItemText
                  primary={label}
                  primaryTypographyProps={{
                    fontSize: "0.8rem",
                    fontWeight: isActive(path) ? 500 : 400,
                    color: isActive(path) ? "#fff" : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Collapse>

        {/* ===== Manager / Admin Standalone Items ===== */}
        <Box sx={{ mx: 2, my: 1.5, borderTop: "1px solid rgba(255,255,255,0.06)" }} />

        {/* Employees Leave Requests */}
        {(role === "admin" ||
          role === "manager" ||
          role === "store manager") && (
            <ListItem
              button
              onClick={() => handleNavigation("/ManagerleaveRequest")}
              className={`sidebar-item ${isActive("/ManagerleaveRequest") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/ManagerleaveRequest")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/ManagerleaveRequest")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/ManagerleaveRequest")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <GroupAdd
                  sx={{
                    fontSize: 18,
                    color: isActive("/ManagerleaveRequest")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Employees Leave Requests"
                primaryTypographyProps={{
                  fontWeight: isActive("/ManagerleaveRequest") ? 600 : 400,
                  color: isActive("/ManagerleaveRequest")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Employees Overtime Requests */}
        {(role === "admin" ||
          role === "manager" ||
          role === "store manager") && (
            <ListItem
              button
              onClick={() => handleNavigation("/ManagerOvertimeRequests")}
              className={`sidebar-item ${isActive("/ManagerOvertimeRequests") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/ManagerOvertimeRequests")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/ManagerOvertimeRequests")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/ManagerOvertimeRequests")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <AccessTime
                  sx={{
                    fontSize: 18,
                    color: isActive("/ManagerOvertimeRequests")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Employees Overtime Requests"
                primaryTypographyProps={{
                  fontWeight: isActive("/ManagerOvertimeRequests") ? 600 : 400,
                  color: isActive("/ManagerOvertimeRequests")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Outside Attendance Approvals */}
        {(role === "admin" ||
          role === "manager" ||
          role === "store manager") && (
            <ListItem
              button
              onClick={() => handleNavigation("/ManagerAttendanceApprovals")}
              className={`sidebar-item ${isActive("/ManagerAttendanceApprovals") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/ManagerAttendanceApprovals")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/ManagerAttendanceApprovals")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/ManagerAttendanceApprovals")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <LocationOn
                  sx={{
                    fontSize: 18,
                    color: isActive("/ManagerAttendanceApprovals")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Outside Attendance Approvals"
                primaryTypographyProps={{
                  fontWeight: isActive("/ManagerAttendanceApprovals") ? 600 : 400,
                  color: isActive("/ManagerAttendanceApprovals")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Attendance Regularization */}
        {(role === "admin" || role === "manager" || role === "employee") && (
            <ListItem
              button
              onClick={() => handleNavigation("/AttendanceRegularization")}
              className={`sidebar-item ${isActive("/AttendanceRegularization") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/AttendanceRegularization")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/AttendanceRegularization")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/AttendanceRegularization")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <AssignmentTurnedIn
                  sx={{
                    fontSize: 18,
                    color: isActive("/AttendanceRegularization")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Attendance Regularization"
                primaryTypographyProps={{
                  fontWeight: isActive("/AttendanceRegularization") ? 600 : 400,
                  color: isActive("/AttendanceRegularization")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Add Notification */}
        {(role === "admin" ||
          role === "manager" ||
          role === "store manager") && (
            <ListItem
              button
              onClick={() => handleNavigation("/NotificationForm")}
              className={`sidebar-item ${isActive("/NotificationForm") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/NotificationForm")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/NotificationForm")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/NotificationForm")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <AssignmentTurnedIn
                  sx={{
                    fontSize: 18,
                    color: isActive("/NotificationForm")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Add Notification"
                primaryTypographyProps={{
                  fontWeight: isActive("/NotificationForm") ? 600 : 400,
                  color: isActive("/NotificationForm")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Timesheet Analysis */}
        {(role === "admin" ||
          role === "manager" ||
          role === "store manager") && (
            <ListItem
              button
              onClick={() => handleNavigation("/timesheetacess")}
              className={`sidebar-item ${isActive("/timesheetacess") ? "active-item" : ""}`}
              sx={{
                borderRadius: "8px",
                mx: 1,
                py: 0.8,
                px: 1.5,
                mb: 0.5,
                backgroundColor: isActive("/timesheetacess")
                  ? "rgba(102,126,234,0.15)"
                  : "transparent",
                borderLeft: isActive("/timesheetacess")
                  ? "3px solid #667eea"
                  : "3px solid transparent",
                "&:hover": {
                  backgroundColor: isActive("/timesheetacess")
                    ? "rgba(102,126,234,0.2)"
                    : "rgba(255,255,255,0.06)",
                },
                transition: "all 0.15s ease",
              }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <AssignmentTurnedIn
                  sx={{
                    fontSize: 18,
                    color: isActive("/timesheetacess")
                      ? "#667eea"
                      : "rgba(255,255,255,0.5)",
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Timesheet Analysis"
                primaryTypographyProps={{
                  fontWeight: isActive("/timesheetacess") ? 600 : 400,
                  color: isActive("/timesheetacess")
                    ? "#fff"
                    : "rgba(255,255,255,0.7)",
                  fontSize: "0.8125rem",
                }}
              />
            </ListItem>
        )}

        {/* Bottom spacing */}
        <Box sx={{ pb: 3 }} />
      </List>
    </Box>
  );
};

const Sidebar = ({ mobileOpen, handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const drawer = <SidebarContent />;

  return (
    <Box
      component="nav"
      sx={{
        width: { md: drawerWidth },
        flexShrink: { md: 0 },
        position: "relative",
      }}
      aria-label="sidebar navigation"
    >
      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          className="dark-sidebar-backdrop"
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            zIndex: 1300,
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "#1a1d21",
              borderRight: "1px solid rgba(255,255,255,0.06)",
              pt: "56px",
            },
          }}
        >
          {drawer}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          open
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              bgcolor: "#1a1d21",
              borderRight: "1px solid rgba(255,255,255,0.06)",
              top: "64px",
              height: "calc(100vh - 64px)",
              zIndex: 1000,
            },
          }}
        >
          {drawer}
        </Drawer>
      )}
    </Box>
  );
};

export default Sidebar;
